import Meta from '@/components/common/Meta'

import StudentStorageAndShippingServicesPage from '@/v2/components/pages/landing-pages/student-storage-and-shipping-services-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/student-storage-and-shipping-services-page'

interface StudentStorageAndShippingServicesPageProps {}

const Page: React.FC<StudentStorageAndShippingServicesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.student_storage_and_shipping_services.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.student_storage_and_shipping_services?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.student_storage_and_shipping_services?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <StudentStorageAndShippingServicesPage />
    </>
  )
}

export default Page
